import React from 'react';
import Base64 from 'Base64';
import { Input } from 'reactstrap';

import {isEqual} from "../lib/ObjectUtil";

class ComboBoxSearch extends React.Component  {
    constructor(props){
        super(props);
        this.state = {
            data : [],
            options			: this.props.options, 
            defaultValue	: this.props.default, 
            table			: this.props.table, 
            valueField		: this.props.valueField, 
            displayField	: this.props.displayField, 
            filterField		: this.props.filterField, 
            filterValue		: this.props.filterValue,
            orderby 		: this.props.orderby,
            attribute 		: this.props.attribute,
            title			: this.props.title,
            searchValue     : '', // <-- Add this line
            isOpen: false,
            selected: null,
        };
        this.loaddata(this.props.table, this.props.filterField, this.props.filterValue, this.props.orderby);
    }
    loaddata = (_table, _filterField, _filterValue, _orderBy) =>{
		let requestOptions = {
			method: 'GET',
			headers: {
				'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
			}
		};
		fetch('https://renobuilding.ca/wp-json/reno/v1/query?table=' + _table + '&filterfield=' + _filterField + '&filtervalue=' + _filterValue + (_orderBy?'&order=' + _orderBy:'') , requestOptions)
		.then(response => {
		    return Promise.all([response.json(),response])
		})
		.then(([data,response]) => {
            this.setState({data : data});
				if(data.length==1){
					if(this.props)this.props.callback((this.state.valueField.indexOf(',')!=-1?data[0][this.state.valueField.split(',')[0]]+','+data[0][this.state.valueField.split(',')[1]]:data[0][this.state.valueField]));
				}
			//console.log(responseData);
		})
		.catch(error => {
			console.error('Error:', error);
		})		

    }
    componentWillReceiveProps(nextProps, prevState){
		if(!isEqual(nextProps, this.props)){
            this.loaddata(nextProps.table, nextProps.filterField, nextProps.filterValue, nextProps.orderby);
		}
    }
    handleInputClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    handleOptionClick = (item) => {
        this.setState({ selected: item, isOpen: false, searchValue: '' });
        if (this.props.onChange) {
            // Create a synthetic event similar to native select
            const event = {
                target: {
                    value: this.props.valueField
                        ? this.props.valueField.split(',').map(f => item[f]).join(',')
                        : item.id,
                    item: item // pass the whole item if needed
                }
            };
            this.props.onChange(event);
        }
    };

    onSearchChange = (e) => {
        this.setState({ searchValue: e.target.value });
    };

    render(){
        const { data, searchValue, isOpen, selected } = this.state;
        const displayField = this.props.displayField || 'name';
        const valueField = this.props.valueField || 'id';

        // Filter data based on searchValue
        const filteredData = data.filter(item =>
            displayField
                .split(',')
                .some(field => (item[field] || '').toString().toLowerCase().includes(searchValue.toLowerCase()))
        );

        return (
            <div style={{ position: 'relative', width: '100%' }}>
                <Input
                    type="text"
                    readOnly
                    value={selected ? displayField.split(',').map(f => selected[f]).join(' ') : ''}
                    onClick={this.handleInputClick}
                    placeholder={this.props.title || (this.state.title? this.state.title : '-')}
                    style={{ paddingRight: 30, width: '100%' }}
                />
                {/* Drop-down icon */}
                <span
                    style={{
                        position: 'absolute',
                        right: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        fontSize: 18,
                        color: '#888'
                    }}
                >
                    ▼
                </span>
                {isOpen && (
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        background: '#fff',
                        border: '1px solid #ccc',
                        maxHeight: 200,
                        overflowY: 'auto',
                        width: '100%'
                    }}>
                        <Input
                            type="text"
                            placeholder="Search..."
                            value={searchValue}
                            onChange={this.onSearchChange}
                            autoFocus
                            style={{ margin: 5, width: 'calc(100% - 10px)' }}
                        />
                        {filteredData.length === 0 && (
                            <div style={{ padding: 10, color: '#888' }}>No results</div>
                        )}
                        {([{key:"[New]",value:"-1"}]).map(item=>(
                            <div
                                key={item.value}
                                style={{ padding: 10, cursor: 'pointer' }}
                                onClick={() => this.handleOptionClick(item)}
                            >
                                {item.key}
                            </div>
                        ))}
                        {filteredData.map(item => (
                            <div
                                key={item[valueField]}
                                style={{ padding: 10, cursor: 'pointer' }}
                                onClick={() => this.handleOptionClick(item)}
                            >
                                {displayField.split(',').map(f => item[f]).join(' ')}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default ComboBoxSearch;